import { render, staticRenderFns } from "./DownloadHeroSection.vue?vue&type=template&id=50d42949&scoped=true"
import script from "./DownloadHeroSection.vue?vue&type=script&lang=js"
export * from "./DownloadHeroSection.vue?vue&type=script&lang=js"
import style0 from "./DownloadHeroSection.vue?vue&type=style&index=0&id=50d42949&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d42949",
  null
  
)

export default component.exports